import React from "react";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

export default function Footer() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className={cn(
        "relative pt-16 pb-10 border-t",
        isDark ? "border-white/10 bg-black" : "border-black/10 bg-white"
      )}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
          <div className="flex items-center gap-4">
            <img
              src="https://customer-assets.emergentagent.com/job_brams-portfolio/artifacts/ssol55p1_Logo%20bramsgraphic%20white.png"
              alt="BSG — Brams Graphic Design"
              className={cn("h-20 md:h-24 object-contain", isDark ? "" : "invert")}
            />
            <div>
              <div className="font-display font-bold text-2xl md:text-3xl tracking-tighter">
                Brams Graphic Design
              </div>
              <div className={cn("text-[10px] uppercase tracking-[0.4em] mt-2", isDark ? "text-white/55" : "text-black/55")}>
                Studio de Design Graphique
              </div>
            </div>
          </div>
            <p className={cn("mt-5 max-w-md text-sm font-body font-light leading-relaxed", isDark ? "text-white/55" : "text-black/55")}>
              Un studio indépendant qui crée des identités visuelles et des logos pour des marques ambitieuses partout dans le monde.
            </p>
          </div>

          <div className="flex flex-col md:items-end gap-4">
            <a
              href="mailto:bramsgraphic7@gmail.com"
              data-testid="footer-email"
              className={cn(
                "font-display tracking-tight text-base transition-opacity",
                isDark ? "text-white hover:opacity-80" : "text-black hover:opacity-80"
              )}
            >
              bramsgraphic7@gmail.com
            </a>
            <a
              href="https://snapchat.com/add/bramsgraphic78"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-snapchat"
              className={cn(
                "text-sm font-body transition-opacity",
                isDark ? "text-white/70 hover:opacity-100" : "text-black/70 hover:opacity-100"
              )}
            >
              Snapchat · bramsgraphic78
            </a>
          </div>
        </div>

        <div
          className={cn(
            "mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t",
            isDark ? "border-white/10" : "border-black/10"
          )}
        >
          <p className={cn("text-xs font-body", isDark ? "text-white/50" : "text-black/50")}>
            © {year} Brams Graphic Design. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              data-testid="footer-privacy"
              className={cn("text-xs font-body hover:opacity-100 transition-opacity",
                isDark ? "text-white/60" : "text-black/60")}
            >
              Confidentialité
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              data-testid="footer-terms"
              className={cn("text-xs font-body hover:opacity-100 transition-opacity",
                isDark ? "text-white/60" : "text-black/60")}
            >
              Conditions
            </a>
            <span className={cn("text-xs font-body", isDark ? "text-white/40" : "text-black/40")}>
              Fait avec soin.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
